import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@bo-client/config/config.service';
import { GisDataModel } from '@bo-client/shared/models/gisData';
import { AreaTypeEnum } from '@bo-client/activation-management/shared/models/commissioningModel';

import { map, switchMap } from 'rxjs/operators';
import { AutocompleteStrategy } from '@bo-client/shared/components/get-gis-data/autocomplete.strategy';
import { MapAreasEVIEnum } from '@bo-client/activation-management/shared/components/select-gis-data/select-gis-data.model';

@Injectable({
  providedIn: 'root'
})
export class EviAutocompleteStrategy implements AutocompleteStrategy {
  constructor(public httpClientBack: HttpClient, public configService: ConfigService) {}

  getCitySuggestions(val: string): Observable<GisDataModel[]> {
    return this.httpApiEVI('cities?plz_city_lookup=' + val.toString() + '&limit=20').pipe(
      map((x) => this.listCityToShow(x))
    );
  }

  getStreetSuggestions(selectedGisData: GisDataModel, val: string): Observable<GisDataModel[]> {
    return this.httpApiEVI(
      'streets?street_lookup=' +
        val.toString() +
        '&city_id=' +
        selectedGisData.cityId +
        '&limit=20&zipCode=' +
        selectedGisData.zipCode
    ).pipe(map((x) => this.listStreetToShow(x)));
  }

  getStreetNoSuggestions(selectedGisData: GisDataModel, val: string): Observable<GisDataModel[]> {
    return this.httpApiEVI(
      'houseNo?houseNo_lookup=' + val.toString() + '&street_id=' + selectedGisData.streetId + '&limit=20'
    ).pipe(
      switchMap((houseNoList) => {
        const sources = [];
        houseNoList.forEach((houseNo) =>
          sources.push(
            this.httpApiEVI(
              'availability?lon=' + houseNo.latitude + '&lat=' + houseNo.longitude + '&radius=400'
            )
          )
        );
        return forkJoin(...sources).pipe(
          map((resArrAreas) => this.listStreetNoToShow(houseNoList, resArrAreas))
        );
      })
    );
  }

  listCityToShow(apiRes: any): GisDataModel[] {
    // to review
    apiRes = apiRes.filter((x) => x.cityId);
    return apiRes.map((ele) => ({
      cityId: ele.cityId,
      city: ele.city,
      zipCode: ele.zipCode,
      // to review
      orgEinheit: 'evi'
    }));
  }

  listStreetToShow(apiRes: any): GisDataModel[] {
    return apiRes;
  }

  listStreetNoToShow(houseNoList: any[], resArrAreas: any[]): GisDataModel[] {
    houseNoList.map((x, idx) => {
      x.availableAreas = resArrAreas[idx];
    });
    return houseNoList.map((ele) => ({
      id: ele.id,
      houseNo: ele.houseNo,
      houseNoAddition: ele.houseNoAddition,
      longitude: ele.longitude,
      latitude: ele.latitude,
      // todo vorübergehende Lösung weil areas list leer war
      availableAreas: ele.availableAreas && ele.availableAreas.length > 0 ? ele.availableAreas : []
    }));
  }

  isAvailableArea(areaType: AreaTypeEnum, selectedOption: GisDataModel): boolean {
    let isAvailable = false;
    if (selectedOption.availableAreas) {
      const idxEVIEnum = MapAreasEVIEnum.findIndex((ele) => ele.area.toLowerCase() == areaType.toLowerCase());
      if (idxEVIEnum != -1) {
        const idxCode = selectedOption.availableAreas.findIndex(
          (ele) => ele.typ.toLowerCase() == MapAreasEVIEnum[idxEVIEnum].code.toLowerCase()
        );
        if (idxCode != -1) {
          isAvailable = true;
        }
      }
    }
    return isAvailable;
  }

  private httpApiEVI(apiUri: string): Observable<any> {
    return this.httpClientBack.get<any>(`${this.configService.getSettings('gisURLEVI')}${apiUri}`);
  }
}
